<section class="flex flex-col gap-12">
  <app-section-header
    [description]="
      'Deliver updates to as many devices as you need all around the world'
    "
    [icon]="'@tui.trending-up'"
    [subtitle]="'Statistics'"
    [title]="'Built to scale'"
  >
  </app-section-header>
  <div class="flex w-full flex-col items-center gap-6">
    @let data = statistics.data();

    <div class="grid w-full grid-cols-1 gap-8 md:grid-cols-3">
      <div
        class="flex flex-col rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
      >
        <div class="mb-4 flex flex-row items-center">
          <tui-icon icon="@tui.arrow-down-to-line" class="mr-2" />
          <span class="text-xl font-bold md:text-2xl"
            ><span
              [countUp]="data?.allTimeAppBundleDownloads || 0"
              [options]="{ enableScrollSpy: true, scrollSpyOnce: true }"
              [reanimateOnClick]="false"
              >0</span
            >+</span
          >
        </div>
        <span class="text-balance text-lg">Updates delivered</span>
        <span class="text-base text-gray-500">since launch</span>
      </div>
      <div
        class="flex flex-col rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
      >
        <div class="mb-4 flex flex-row items-center">
          <tui-icon icon="@tui.smartphone" class="mr-2" />
          <span class="text-xl font-bold md:text-2xl"
            ><span
              [countUp]="data?.currentMonthAppDevices || 0"
              [options]="{ enableScrollSpy: true, scrollSpyOnce: true }"
              [reanimateOnClick]="false"
              >0</span
            >+</span
          >
        </div>
        <span class="text-balance text-lg">Monthly active devices</span>
        <span class="text-base text-gray-500">receiving updates</span>
      </div>
      <div
        class="flex flex-col rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
      >
        <div class="mb-4 flex flex-row items-center">
          <tui-icon icon="@tui.activity" class="mr-2" />
          <span class="text-xl font-bold md:text-2xl"
            >><span
              [countUp]="99.99"
              [options]="{
                enableScrollSpy: true,
                scrollSpyOnce: true,
                decimalPlaces: 2,
              }"
              [reanimateOnClick]="false"
              >0</span
            >%</span
          >
        </div>
        <span class="text-balance text-lg">Total uptime</span>
        <span class="text-base text-gray-500">since launch</span>
      </div>
    </div>
    <span class="flex items-center gap-4 text-base text-gray-500">
      <tui-pulse [tuiAppearance]="'positive'" /><span
        >Last updated {{ data?.updatedAt | timeAgo }}</span
      >
    </span>
  </div>
</section>
